import React from 'react'

function ContactUs() {
  return <h1 className="text-6xl">{'<ContactUs />'}</h1>
}

export default ContactUs
